/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnfreezeAndResetCreditPullRetries_unfreezeAndResetCreditPullRetries_Status = { readonly __typename: 'Status', readonly message: string | null };

export type UnfreezeAndResetCreditPullRetries_Mutation = { readonly __typename: 'Mutation', readonly unfreezeAndResetCreditPullRetries: UnfreezeAndResetCreditPullRetries_unfreezeAndResetCreditPullRetries_Status | null };


export type UnfreezeAndResetCreditPullRetriesVariables = _Types.Exact<{
  companyDivvyUuid: _Types.Scalars['String']['input'];
  salesforceCreditId: _Types.Scalars['String']['input'];
}>;


export type UnfreezeAndResetCreditPullRetries = UnfreezeAndResetCreditPullRetries_Mutation;


export const UnfreezeAndResetCreditPullRetriesDocument = gql`
    mutation UnfreezeAndResetCreditPullRetries($companyDivvyUuid: String!, $salesforceCreditId: String!) {
  unfreezeAndResetCreditPullRetries(
    companyDivvyUuid: $companyDivvyUuid
    salesforceCreditId: $salesforceCreditId
  ) {
    message
  }
}
    `;
export type UnfreezeAndResetCreditPullRetriesMutationFn = Apollo.MutationFunction<UnfreezeAndResetCreditPullRetries, UnfreezeAndResetCreditPullRetriesVariables>;

/**
 * __useUnfreezeAndResetCreditPullRetries__
 *
 * To run a mutation, you first call `useUnfreezeAndResetCreditPullRetries` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfreezeAndResetCreditPullRetries` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfreezeAndResetCreditPullRetries, { data, loading, error }] = useUnfreezeAndResetCreditPullRetries({
 *   variables: {
 *      companyDivvyUuid: // value for 'companyDivvyUuid'
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *   },
 * });
 */
export function useUnfreezeAndResetCreditPullRetries(baseOptions?: Apollo.MutationHookOptions<UnfreezeAndResetCreditPullRetries, UnfreezeAndResetCreditPullRetriesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfreezeAndResetCreditPullRetries, UnfreezeAndResetCreditPullRetriesVariables>(UnfreezeAndResetCreditPullRetriesDocument, options);
      }
export type UnfreezeAndResetCreditPullRetriesHookResult = ReturnType<typeof useUnfreezeAndResetCreditPullRetries>;
export type UnfreezeAndResetCreditPullRetriesMutationResult = Apollo.MutationResult<UnfreezeAndResetCreditPullRetries>;
export type UnfreezeAndResetCreditPullRetriesMutationOptions = Apollo.BaseMutationOptions<UnfreezeAndResetCreditPullRetries, UnfreezeAndResetCreditPullRetriesVariables>;